import { yupResolver } from "@hookform/resolvers";
import { FC, Fragment, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useFormState } from "../../../hooks/useFormState";
import { LessonBuilderContext } from "../../../hooks/useLessonBuilder";
import {
    LessonTopicPageVideoCreateModel,
    LessonTopicPageVideoCreateModelValidationSchema,
} from "../../../models/crud/lessontopicpagevideos/LessonTopicPageVideoCreateModel";
import { LessonBuilderService } from "../../../services/LessonBuilderService";
import { nameof } from "../../../utils/Helpers";
import { Hidden } from "../../fields/Hidden";
import { FieldLessonTopicPageVideoID } from "../../fields/lesson-topic-page-videos/FieldLessonTopicPageVideoID";
import { Loading } from "../../Loading";

const nameLessonTopicPageID = nameof<LessonTopicPageVideoCreateModel>("LessonTopicPageID");

export const AddVideoModal: FC = () => {
    const [modal, setModal] = useState(false);

    const { addPageItem, page } = useContext(LessonBuilderContext);
    const { setLoading, confirmServerError, loading } = useFormState();

    const { register, handleSubmit, errors } = useForm<LessonTopicPageVideoCreateModel>({
        resolver: yupResolver(LessonTopicPageVideoCreateModelValidationSchema),
    });

    const toggleModal = () => setModal(!modal);

    const onSubmit = handleSubmit(model => {
        setLoading(true);

        LessonBuilderService.addVideo(model)
            .then(x => {
                addPageItem(x.Data);
                setModal(false);
                setLoading(false);
            })
            .catch(confirmServerError);
    });

    return (
        <Fragment>
            <Button type="button" onClick={toggleModal}>
                Add video
            </Button>

            <Modal external={false} isOpen={modal} toggle={toggleModal} centered={true}>
                {loading ? (
                    <Loading />
                ) : (
                    page && (
                        <form onSubmit={onSubmit}>
                            <ModalHeader>Add video</ModalHeader>
                            <ModalBody>
                                <Hidden name={nameLessonTopicPageID} value={page.ID} register={register} />
                                <FieldLessonTopicPageVideoID register={register} errors={errors} />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary">Add</Button>
                                <Button type="button" onClick={toggleModal}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </form>
                    )
                )}
            </Modal>
        </Fragment>
    );
};
